"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreightTrackingInfoExternalIdType = void 0;
exports.FreightTrackingInfoExternalIdType = {
    FREIGHT_SHIPMENT: 'FREIGHT_SHIPMENT',
    INBOUND_SHIPMENT: 'INBOUND_SHIPMENT'
};
//# sourceMappingURL=freight-tracking-info-external-id-type.js.map